import script from "./GoOut.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoOut.vue?vue&type=script&lang=ts&setup=true"

import "./GoOut.vue?vue&type=style&index=0&id=61cf572a&lang=scss&scoped=true"

import exportComponent from "/Users/hexor/Documents/vue-workspace/xw-koudai-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61cf572a"]])

export default __exports__